import React, { useState, useEffect } from "react";
import "../Assets/Styles.css";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
//import { db } from "../Components/firebase";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import PVUTable from "../Components/PVUTable";
//import { Seasons, PlantsType } from "../context/GlobalVariables";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import SeasonPredict from '../Components/SeasonPredict';
import Tooltip from '@material-ui/core/Tooltip';
const vertical = "top";
const horizontal = "right";
var apiKey = "0a5e3cb0430a1078565c";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function PVUCalculator() {
  const [open, setOpen] = React.useState(false);
  const [CurrencyID, setCurrencyID] = React.useState("");
  const [CurrencyList, setCurrencyList] = useState([]);
  const [selectedCurrency, setselectedCurrency] = useState({
    CountryName: "",
    CurrencyId: "",
    Symbol: "",
  });
  const [PVUUSD, setPVUUSD] = useState(0);
  const [ConversionForm, setConversionForm] = useState({
    LE: 0,
    Ammount: 0,
    conversionRatio: "",
    Message: "",
  });
  const [Ratio, setRatio] = useState(1);

  async function getList() {
    var myHeaders = new Headers();
    myHeaders.set("accept", "application/json");
    var myInit = { method: "GET", headers: myHeaders };
    var URL = "https://free.currconv.com/api/v7/countries?apiKey=" + apiKey;

    return await fetch(URL, myInit)
      .then((data) => data.json())
      .then((item) => item.results);
  }
  async function getConversionRatio(currid) {
    var fromCurrency = encodeURIComponent("USD");
    var toCurrency = encodeURIComponent(currid);
    var query = fromCurrency + "_" + toCurrency;
    var URL =
      "https://free.currconv.com/api/v7/convert?q=" +
      query +
      "&compact=ultra&apiKey=" +
      apiKey;
    var call = await fetch(URL);
    var { respuesta } = call;
    var miRespuesta = await call.json();
    setRatio(+miRespuesta[query]);
  }
  async function getPVU() {
    var coins = [];
    var pvuUSD = {};
    var myHeaders = new Headers();
    var Currency = 0;
    myHeaders.set("accept", "application/json");

    var myInit = { method: "GET", headers: myHeaders };
    var URL =
      "https://api.coingecko.com/api/v3/coins/list?include_platform=false";

    await fetch(URL, myInit)
      .then((response) => response.json())
      .then((data) => (coins = data));

    var PVU = coins.filter((coin) => coin.symbol === "pvu")[0];

    URL =
      "https://api.coingecko.com/api/v3/coins/" +
      PVU.id +
      "?tickers=false&market_data=true&community_data=false&developer_data=false&sparkline=false";
    await fetch(URL, myInit)
      .then((response) => response.json())
      .then((data) => (pvuUSD = data));
    var PVUValue = pvuUSD.market_data.current_price.usd;
    setPVUUSD(PVUValue);
  }
  useEffect(() => {
    let mounted = true;
    getList().then((items) => {
      if (mounted) {
        getPVU();
        var x = items;
        var keys = Object.keys(items);
        var currencies = keys.map((item) => {
          var obj = {
            CountryName: x[item].name,
            CurrencyId: x[item].currencyId,
            Symbol: x[item].currencySymbol,
          };
          return obj;
        });

        var sortedCurrency = currencies.sort((a, b) =>
          a.CountryName > b.CountryName
            ? 1
            : b.CountryName > a.CountryName
            ? -1
            : 0
        );
        setCurrencyList(sortedCurrency);
      }
    });

    return () => (mounted = false);
  }, []);
  const handleChange = (event) => {
    var eventText=event.target.value;
    var country=eventText.substring(0,eventText.indexOf(" - "));
    var currid=event.target.value.substring(eventText.length-3,eventText.length);
    setCurrencyID(currid);
    var obj = CurrencyList.find(
      (item) => item.CountryName === country
    );
    setselectedCurrency({
      CountryName: obj.CountryName,
      CurrencyId: obj.CurrencyId,
      Symbol: obj.Symbol,
    });
    getConversionRatio(obj.CurrencyId);
  };
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const HandleTextChange = (Value, Field) => {
    setConversionForm({ ...ConversionForm, [Field]: parseFloat(Value) });
  };
  const Convert = () => {
    setConversionForm({
      ...ConversionForm,
      Ammount: (
        (parseFloat(ConversionForm.LE) / 150) *
        0.95 *
        Ratio *
        PVUUSD
      ).toFixed(2),
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        paddingRight: "30px",
        margin: "auto",
      }}
    >
      <div>
        <Typography variant="h2" component="h2" gutterBottom className="Header">
          PVU Calculator
        </Typography>
        <Divider />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          flexDirection: "row",
        }}
      >
        <div className="ConvertPVUContainers Conversion">
          <form
            noValidate
            autoComplete="off"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <TextField
              style={{ margin: "10px", minWidth: "30%" }}
              id="standard-read-only-input"
              label="LE Amount"
              type="number"
              onChange={(event) => {
                HandleTextChange(event.target.value, "LE");
              }}
            />
            <FormControl style={{ margin: "10px"}}>
              <InputLabel htmlFor="age-native-simple">Currency</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedCurrency.CountryName+" - "+selectedCurrency.CurrencyId}
                onChange={handleChange}
              >
                {CurrencyList.map((element, i) => {
                  return (
                    <MenuItem value={element.CountryName + " - "+element.CurrencyId} key={i}>
                      {element.CountryName + " - " + element.CurrencyId}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Button
              variant="outlined"
              color="secondary"
              style={{ margin: "10px", minWidth: "24%" }}
              onClick={() => {
                Convert();
              }}
            >
              CONVERT
            </Button>
            <TextField
              style={{ margin: "10px", minWidth: "24%" }}
              id="standard-read-only-input"
              label="Amount"
              value={selectedCurrency.Symbol + " " + ConversionForm.Ammount}
              InputProps={{
                readOnly: true,
              }}
            />
          </form>
        </div>
        <div className="ConvertPVUContainers Risk">
          <SeasonPredict/>
        </div>
      </div>

      <PVUTable />
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose} severity="success">
          Form submitted successfully
        </Alert>
      </Snackbar>
    </div>
  );
}

export default PVUCalculator;
